import { z } from "zod";
import { hasAtLeastOneField, optionalBoolean, optionalDefaultBoolean, optionalNonEmptyText, optionalNumber, requiredId, requiredText } from "../lib/schemas";
export const documentIdParamSchema = z.object({
    documentId: requiredId,
});
export const getDocumentOutputSchema = z.object({
    id: requiredId,
    name: requiredText,
    isRenewable: optionalDefaultBoolean(true),
    renewalPeriodDays: optionalNumber,
});
export const createDocumentInputSchema = z.object({
    name: requiredText,
    isRenewable: optionalDefaultBoolean(true),
    renewalPeriodDays: optionalNumber,
});
export const updateDocumentInputSchema = z.object({
    name: optionalNonEmptyText,
    isRenewable: optionalBoolean,
    renewalPeriodDays: optionalNumber,
}).refine(hasAtLeastOneField, {
    message: "At least one field is required",
});
